import { ADDRESS_STEP_PROVINCIA } from "Theconstants";
import {
  RegularInputs,
  SelectInput,
} from "pages/checkout/auxiliaries/steps/addressData";
import React from "react";
import styled, { css } from "styled-components";

type ColorInputWhenError = { error: string | undefined };
//@ts-ignore
const baseStyleErrors = css`
  border: 2px solid
    ${(props) =>
      //@ts-ignore for now this is the only solution I could find, I dont like it, 26/12/23
      props.error ? props.theme.red : props.theme.border};

  padding: 10px;
`;
export const Label = styled.label`
  display: flex;
  flex: 1;
`;
export const Input = styled.input<ColorInputWhenError>`
  font-size: inherit;
  width: 100%;
  ${baseStyleErrors}
`;
export const ErrorMessage = styled.p`
  color: ${(props) => props.theme.red};
  font-size: calc(var(--fontSmall) - 0.1rem);
  font-weight: 400;
  padding-bottom: 5px;
`;
export const InputControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  @media (max-width: 600px) {
    gap: 2px;
  }
`;
export const SelectProv = styled.select<ColorInputWhenError>`
  cursor: pointer;
  font-size: inherit;

  ${baseStyleErrors}
`;
export const OptionProv = styled.option``;

type CommonProps = {
  changeInput: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  inputsEnvio: ICompra["datosEnvio"];
  errors: { [K in keyof ICompra["datosEnvio"]]?: string };
};

type FinalProps =
  | (RegularInputs & CommonProps)
  | ({ prov: string[] } & SelectInput & CommonProps);

export default function AddressInputLine(props: FinalProps) {
  const { changeInput, inputsEnvio, errors } = props;

  if (!props.select) {
    const { required, id, type, placeholder, innerText } = props;

    return (
      <InputControl>
        <Label htmlFor={id}>{innerText}</Label>
        <Input
          id={id}
          type={type}
          placeholder={placeholder}
          onChange={changeInput}
          value={inputsEnvio?.[id]}
          name={id}
          required={required}
          error={errors?.[id]}
        ></Input>
        {errors?.[id] && <ErrorMessage>{errors?.[id]}</ErrorMessage>}
      </InputControl>
    );
  }
  const { prov, required, id, innerText } = props;

  return (
    <InputControl>
      <Label htmlFor={id}>{innerText}</Label>
      <SelectProv
        id={id}
        onChange={changeInput}
        value={inputsEnvio?.[id]}
        name={id}
        required={required}
        error={errors?.[id]}
      >
        <OptionProv disabled hidden>
          {ADDRESS_STEP_PROVINCIA}
        </OptionProv>
        {prov?.length && prov.map((i) => <OptionProv key={i}>{i}</OptionProv>)}
      </SelectProv>
      {errors?.[id] && <ErrorMessage>{errors?.[id]}</ErrorMessage>}
    </InputControl>
  );
}
